var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewClaimsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 5.33333H7.99984V6.66667H21.3332V5.33333Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 10.6667H7.99984V12H21.3332V10.6667Z",
    fill: "#B4B4B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 16H7.99984V17.3333H17.3332V16Z",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 26H26.6665V1.33333C26.6665 0.598 26.0685 0 25.3332 0H3.99984C3.2645 0 2.6665 0.598 2.6665 1.33333V28C2.6665 30.206 4.4605 32 6.6665 32H25.3332C27.5392 32 29.3332 30.206 29.3332 28V27.3333C29.3332 26.598 28.7352 26 27.9998 26ZM3.99984 28V1.33333H25.3332V26H10.6665C9.93117 26 9.33317 26.598 9.33317 27.3333V28C9.33317 29.4707 8.13717 30.6667 6.6665 30.6667C5.19584 30.6667 3.99984 29.4707 3.99984 28ZM25.3332 30.6667H9.63984C10.2758 29.958 10.6665 29.0253 10.6665 28V27.3333H27.9998V28C27.9998 29.4707 26.8038 30.6667 25.3332 30.6667Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewClaimsMenuIcon);
export default __webpack_public_path__ + "static/media/view_claims_menu_icon.3feee2da31daa417dc858e3142fa362d.svg";
export { ForwardRef as ReactComponent };